import { ADD_NEW_MESSAGE, REMOVE_MESSAGE } from "constants/constants";

const initialState = {
  messages: [],
  count: 0
};

const WebsocketReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case ADD_NEW_MESSAGE:
      const listMessagesAddMethod = [...state.messages];

      listMessagesAddMethod.push(action.payload);
      return { messages: listMessagesAddMethod, count: state.count + 1 };
    case REMOVE_MESSAGE:
      const listMessageRemoveMethod = [...state.messages];

      let indexMsg = listMessageRemoveMethod.findIndex((msg) => msg['Payload']['id'] == action.payload);
      if (indexMsg > -1) {
        listMessageRemoveMethod.splice(indexMsg, 1);
      }
      return { messages: listMessageRemoveMethod, count: state.count - 1 };
    default:
      return state;
  }
};

export default WebsocketReducer;
